import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { NovedadIndService } from '../services/novedad-ind.service';
import { years, semester } from './assets/date';
import { RegistroService } from 'src/app/registro.service';

@Component({
    selector: 'app-modal-devoluciones',
    templateUrl: './modal-devoluciones.component.html',
    styleUrls: [
        './modal-devoluciones.component.css',
        '../../components/view-succes/view-succes.component.css',
    ],
})
export class ModalDevolucionesComponent implements OnInit {
    displayIdl = false;
    mensaje =
        'Por favor seleccione el año y semestre en el que va a diligenciar la información de devoluciones de los productos';
    selectedYear: number;
    selectedSemester;
    years = years;
    semester = semester;
    errorMessages: string[] = [];
    ultimoObjetoCreado;
    NovedadExiste;
    displeyIdlConfirm = false;
    mensajeConfirm = 'confirmación';
    displeyIdl = false;
    nombreBtn = 'Volver';
    confirm = false;

    constructor(
        private router: Router,
        private novedadService: NovedadIndService,
        private registroService: RegistroService
    ) {}

    ngOnInit() {
        const idNovedadGuardado: any =
            this.registroService.listaNovedadesGuardadas.find(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa ===
                    this.registroService.empresaSelected
            );
        this.ultimoObjetoCreado = idNovedadGuardado;
    }

    viewReport() {
        this.displayIdl = true;
    }

    closeReport() {
        this.displayIdl = false;
        this.errorMessages = [];
    }

    pageReport() {
        this.errorMessages = [];
        if (!this.selectedYear) {
            this.errorMessages.push('El año es requerido.');
        }
        if (!this.selectedSemester) {
            this.errorMessages.push('El semestre es requerido.');
        }
        if (this.errorMessages.length === 0) {
            if (this.ultimoObjetoCreado) {
                this.mostrarNovedad();
            } else {
                this.NovedadExist();
            }
        }
    }

    private navigateWithParams() {
        const queryParams: NavigationExtras = {
            queryParams: {
                year: this.selectedYear,
                semester: this.selectedSemester.name,
                semesterDate: this.selectedSemester,
            },
        };
        this.router.navigate(['reporte-devoluciones'], queryParams);
        this.displayIdl = false;
        const idEmpresaSeleccionada = this.registroService.empresaSelected;
        const indexReporteGuardado =
            this.registroService.listaReportesGuardados.findIndex(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa === idEmpresaSeleccionada
            );

        if (indexReporteGuardado !== -1) {
            const nuevosReportes =
                this.registroService.listaReportesGuardados.filter(
                    (agenteVigilado) =>
                        agenteVigilado.idEmpresa !== idEmpresaSeleccionada
                );
            this.registroService.listaReportesGuardados = nuevosReportes;
        }
    }

    public volver() {
        this.router.navigate(['carga-consulta-novedades']);
        this.displeyIdl = false;
    }

    volverConfirm() {
        this.router.navigate(['carga-consulta-novedades']);
        this.displeyIdlConfirm = false;
    }

    continuar() {
        this.navigateWithParams();
        this.displeyIdl = false;
        this.displeyIdlConfirm = false;
    }

    mostrarNovedad() {
        this.displeyIdlConfirm = true;
        this.mensajeConfirm =
            'Tienes una novedad pendiente, se perderán la información avanzada';
    }

    async NovedadExist() {
        try {
            this.NovedadExiste = await this.novedadService.getNovedadDate(
                this.selectedYear.toString(),
                this.selectedSemester.toString()
            );
            if (this.NovedadExiste.length === 0) {
                this.navigateWithParams();
                this.displeyIdlConfirm = false;
            } else {
                this.mensajeConfirm =
                    'La novedad para esta fecha ya existe, ¿Seguro que quiere reemplazarlo?';
                this.displeyIdlConfirm = true;
            }
        } catch (error) {
            throw error;
        }
    }
}
